// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("images/highlight_star.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./ButtonDropdown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./dropdown-arrow-electricGreen.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.Button {
  display: inline-block;
  border: none;
  background-color: #002E33;
  color: #01FF94;
  font-size: 12px;
  font-weight: 700;
  padding: 16px 16px;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  border-radius: 12px;
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
div.Button.accept {
  color: #01FF94;
  background-color: #002E33;
}
div.Button.accept:not(.button-menu-div):hover {
  color: #FFF;
  background-color: #075E42;
}
div.Button.red {
  color: #FFF;
  background-color: #D92D20;
}
div.Button.red:hover {
  background-color: #951307;
}
div.Button.premium {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 10px center;
  background-size: 20px;
}
div.Button.filter {
  background-color: #FFF;
  color: #002E33;
  font-size: 17px;
  -webkit-text-decoration: underline;
  text-decoration: underline;
}
div.Button.filter:hover {
  color: #01FF94;
  -webkit-text-decoration: none;
  text-decoration: none;
}
div.Button.filter.selected {
  color: #00E383;
  -webkit-text-decoration: none;
  text-decoration: none;
}
div.Button.filter .button-menu {
  -webkit-text-decoration: none;
  text-decoration: none;
  margin-top: 4px !important;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  border: 1px solid #E8E9F0;
  border-radius: 12px;
  background-color: #FFF;
  padding: 8px;
  position: fixed;
}
div.Button.filter .button-menu:before {
  border-color: #E8E9F0 transparent;
  margin-top: -3px;
  right: 40px;
}
div.Button.filter .button-menu:after {
  border-color: white transparent;
  margin-top: -1px;
  right: 40px;
}
div.Button.filterDropDown {
  background-color: #FFF;
  color: #002E33;
  padding: 8px !important;
  border-color: #FFF !important;
}
div.Button.filterDropDown:hover {
  color: #01FF94;
  background-color: #002E33;
}
div.Button.filterDropDown.selected {
  color: #002E33;
}
div.Button.disabled {
  background-color: #F5F6F9;
  color: #D3D6DF;
  cursor: not-allowed;
  pointer-events: none;
}
div.Button.disabled .loadingEllipsis {
  height: 14px;
  margin-bottom: 2px;
  margin-top: -3px;
}
div.Button.disabled .loadingEllipsis .lds-ellipsis {
  height: 14px;
}
div.Button.disabled .loadingEllipsis .lds-ellipsis div {
  top: auto;
  top: initial;
  background: #EDF1F7;
  margin-top: 4px;
}
div.Button.acceptDisabled {
  color: #D3D6DF;
  background-color: #F5F6F9;
}
div.Button:active {
  background-color: #002E33;
}
div.Button:active.accept {
  background-color: #075E42;
}
div.Button:active.cancel {
  background-color: #697588;
}
div.Button:active.disabled {
  background-color: #D3D6DF;
}
div.Button:active.filter {
  background-color: #F5F6F9;
}
div.Button.link {
  color: #002E33;
  background-color: transparent;
  white-space: nowrap;
  border: none;
  border-radius: 0;
  padding: 0;
  font-size: 14px;
  -webkit-text-decoration: underline;
  text-decoration: underline;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(50%, transparent), color-stop(0%, #01FF94));
  background-image: linear-gradient(transparent 50%, #01FF94 0%);
  background-size: auto 200%;
  -webkit-transition: background 0.14s ease-in-out;
  transition: background 0.14s ease-in-out;
}
div.Button.link:hover {
  background-position-y: 100%;
  -webkit-text-decoration: none;
  text-decoration: none;
}
div.Button.normal {
  color: #002E33;
  background-color: #FFF;
  border: 1px solid #D3D6DF;
  -webkit-box-shadow: 0 2px 4px 0 rgba(167, 169, 180, 0.2);
          box-shadow: 0 2px 4px 0 rgba(167, 169, 180, 0.2);
}
div.Button.normal:hover {
  background-color: #E8E9F0;
}
div.Button.premium {
  background: #002E33 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 10px center;
  background-size: 20px;
}
div.Button.premium:hover {
  background-color: #075E42;
}
div.Button.cancel {
  color: #697588;
  background-color: #FFF;
  border: none;
}
div.Button.cancel:hover {
  background-color: rgba(167, 169, 180, 0.12);
}
div.Button.companyName {
  width: 100% !important;
  border-radius: 0px;
  height: 20px;
  line-height: 20px !important;
}
div.Button.green-disabled {
  background-color: #BAEFCB;
}
div.Button.green-disabled:hover {
  background-color: #BAEFCB !important;
}
div.Button img.premium-star {
  height: 10px !important;
  width: 10px !important;
  padding: 3px 7px 5px 5px;
  float: right;
}
div.Button img.icon {
  height: 15px;
  width: 15px;
  float: left;
  margin-right: 18px;
}

div.button-menu-div {
  display: inline-block;
  padding: 0;
}
div.button-menu-div:active {
  background-color: #002E33;
}
div.button-menu-div:active.accept {
  background-color: #002E33;
}
div.button-menu-div:active.cancel {
  background-color: #697588;
}
div.button-menu-div:active.filter {
  background-color: #FFF;
}
div.button-menu-div:active.link {
  background-color: #FFF;
}
div.button-menu-div.link > div.button-menu {
  position: fixed;
  background-color: #FFF;
  -webkit-box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
          box-shadow: 0 10px 15px 0 rgba(38, 40, 47, 0.15);
  margin-left: -35px;
  margin-top: 15px;
  padding: 10px !important;
  border: 1px solid #E8E9F0;
}
div.button-menu-div.link > div.button-menu > div.Button {
  padding: 5px 8px !important;
  border-top: none !important;
  margin: 0 !important;
}
div.button-menu-div.link > div.button-menu hr {
  margin: 5px 8px 5px 8px;
}
div.button-menu-div.link > div.button-menu:after, div.button-menu-div.link > div.button-menu:before {
  right: 10px !important;
}
div.button-menu-div.link > div.button-menu:before {
  border-color: #E8E9F0 transparent;
  margin-top: -3px;
}
div.button-menu-div.link > div.button-menu:after {
  border-color: white transparent;
  margin-top: -1px;
}
div.button-menu-div.link > .menu-base {
  padding: 0;
}
div.button-menu-div.normal .button-menu:after, div.button-menu-div.normal .button-menu:before, div.button-menu-div.accept .button-menu:after, div.button-menu-div.accept .button-menu:before {
  left: calc(50% - 10px);
  top: -5px;
}
div.button-menu-div > .menu-base {
  border-right: 0;
  display: inline-block;
  padding: 16px;
}
div.button-menu-div .dropdown {
  border-radius: 12px;
  background: #002E33 url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;
  background-size: 12px;
  padding: 16px 20px;
  display: inline;
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
div.button-menu-div .dropdown:active {
  background-color: #002E33;
}
div.button-menu-div .dropdown:hover {
  background-color: #075E42;
}
div.button-menu-div .dropdown.link {
  padding-right: 10px !important;
}
div.button-menu-div > div.menu-hidden {
  display: none !important;
}
div.button-menu-div > div.button-menu {
  position: absolute;
  z-index: 1000;
  display: block;
  margin-top: 10px;
  padding: 2px 0 0 0;
  border-radius: 12px;
}
div.button-menu-div > div.button-menu > div.Button {
  border-radius: 8px;
  display: block;
  padding: 14px 16px;
}
div.button-menu-div > div.button-menu > div.Button:first-child {
  border-radius: 8px;
  border-top: none;
}
div.button-menu-div > div.button-menu > div.Button:last-child {
  border-radius: 8px;
}
div.button-menu-div > div.button-menu:before,
div.button-menu-div > div.button-menu:after {
  content: "";
  position: absolute;
  display: block;
  width: 0;
  bottom: auto;
  border-style: solid;
  border-width: 0 8px 8px;
}
div.button-menu-div > div.button-menu:after {
  top: -5px;
  border-color: #5E46D2 transparent;
}
div.button-menu-div > div.button-menu:before {
  top: -5px;
  border-color: #5E46D2 transparent;
}
div.button-menu-div.accept > div.button-menu:after,
div.button-menu-div.accept > div.button-menu:before {
  border-color: #002E33 transparent;
}
div.button-menu-div.accept > .menu-base:active {
  background-color: #075E42;
}
div.button-menu-div.accept > .menu-base:hover {
  background-color: #002E33;
}
div.button-menu-div.accept .dropdown {
  color: #01FF94;
  background: #002E33 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
  -webkit-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
div.button-menu-div.accept .dropdown:active {
  color: #002E33;
  background: #01FF94 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
}
div.button-menu-div.accept .dropdown:hover {
  color: #FFF;
  background: #075E42 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center;
}`, "",{"version":3,"sources":["webpack://./src/client/components/common/Button/Button.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,YAAA;EAEA,yBCJa;EDKb,cCNc;EDQd,eAAA;EACA,gBAAA;EAEA,kBAAA;EACA,eAAA;EAEA,yBAAA;KAAA,sBAAA;MAAA,qBAAA;UAAA,iBAAA;EACA,mBAAA;EA0IA,yCAAA;EAAA,iCAAA;AA9IF;AAME;EACE,cClBY;EDmBZ,yBClBW;ADcf;AAMM;EACE,WCfA;EDgBA,yBCIG;ADRX;AASE;EACE,WCtBI;EDuBJ,yBCpBE;ADaN;AAQI;EACE,yBCYG;ADlBT;AAUE;EACE,+EAAA;EACA,qBAAA;AARJ;AAWE;EACE,sBCnCI;EDoCJ,cC1CW;ED2CX,eAAA;EACA,kCAAA;EAAA,0BAAA;AATJ;AAUI;EACE,cC/CU;EDgDV,6BAAA;EAAA,qBAAA;AARN;AAUI;EACE,cC3CE;ED4CF,6BAAA;EAAA,qBAAA;AARN;AAUI;EACE,6BAAA;EAAA,qBAAA;EACA,0BAAA;EACA,wDAAA;UAAA,gDAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBCrDE;EDsDF,YAAA;EACA,eAAA;AARN;AASM;EACE,iCAAA;EACA,gBAAA;EACA,WAAA;AAPR;AASM;EACE,+BAAA;EACA,gBAAA;EACA,WAAA;AAPR;AAYE;EACE,sBCtEI;EDuEJ,cC7EW;ED8EX,uBAAA;EACA,6BAAA;AAVJ;AAWI;EACE,cClFU;EDmFV,yBClFS;ADyEf;AAWI;EACE,cCrFS;AD4Ef;AAaE;EACE,yBClCK;EDmCL,cCtCK;EDuCL,mBAAA;EACA,oBAAA;AAXJ;AAaI;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;AAXN;AAYM;EACE,YAAA;AAVR;AAWQ;EACE,SAAA;EAAA,YAAA;EACA,mBCrGA;EDsGA,eAAA;AATV;AAeE;EACE,cC1DK;ED2DL,yBCxDK;AD2CT;AAgBE;EACE,yBCpHW;ADsGf;AAgBI;EACE,yBC7FK;AD+EX;AAgBI;EACE,yBCvEG;ADyDT;AAgBI;EACE,yBCxEG;AD0DT;AAgBI;EACE,yBCxEG;AD0DT;AAkBE;EACE,cCrIW;EDsIX,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,kCAAA;EAAA,0BAAA;EACA,0BAAA;EAAA,uBAAA;EAAA,kBAAA;EACA,wHAAA;EAAA,8DAAA;EACA,0BAAA;EACA,gDAAA;EAAA,wCAAA;AAhBJ;AAkBI;EACE,2BAAA;EACA,6BAAA;EAAA,qBAAA;AAhBN;AAsBE;EACE,cC3JW;ED4JX,sBCtJI;EDuJJ,yBAAA;EACA,wDAAA;UAAA,gDAAA;AApBJ;AAqBI;EACE,yBCzGG;ADsFT;AAuBE;EACE,uFAAA;EACA,qBAAA;AArBJ;AAsBI;EACE,yBC9IK;AD0HX;AAwBE;EACE,cC1HK;ED2HL,sBCxKI;EDyKJ,YAAA;AAtBJ;AAuBI;EACE,2CAAA;AArBN;AAyBE;EACE,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;AAvBJ;AA0BE;EACE,yBC9JM;ADsIV;AA0BI;EACE,oCAAA;AAxBN;AA4BE;EACE,uBAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;AA1BJ;AA8BE;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AA5BJ;;AAgCA;EACE,qBAAA;EACA,UAAA;AA7BF;AA+BE;EACE,yBCzNW;AD4Lf;AA8BI;EACE,yBC3NS;AD+Lf;AA8BI;EACE,yBC3KG;AD+IT;AA8BI;EACE,sBC3NE;AD+LR;AA8BI;EACE,sBC9NE;ADkMR;AAiCI;EACE,eAAA;EACA,sBCrOE;EDsOF,wDAAA;UAAA,gDAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;AA/BN;AAiCM;EACE,2BAAA;EACA,2BAAA;EACA,oBAAA;AA/BR;AAiCM;EACE,uBAAA;AA/BR;AAiCM;EAEE,sBAAA;AAhCR;AAkCM;EACE,iCAAA;EACA,gBAAA;AAhCR;AAkCM;EACE,+BAAA;EACA,gBAAA;AAhCR;AAmCI;EACE,UAAA;AAjCN;AAwCM;EAEE,sBAAA;EACA,SAAA;AAvCR;AA4CE;EACE,eAAA;EACA,qBAAA;EACA,aAAA;AA1CJ;AA6CE;EACE,mBAAA;EACA,4EAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;EAAA,iCAAA;AA3CJ;AA6CI;EACE,yBCtSS;AD2Pf;AA6CI;EACE,yBC/QK;ADoOX;AA6CI;EACE,8BAAA;AA3CN;AA+CE;EACE,wBAAA;AA7CJ;AAgDE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA9CJ;AAgDI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;AA9CN;AAiDI;EACE,kBAAA;EACA,gBAAA;AA/CN;AAkDI;EACE,kBAAA;AAhDN;AAqDE;;EAEE,WAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAnDJ;AAqDE;EACE,SAAA;EACA,iCAAA;AAnDJ;AAqDE;EACE,SAAA;EACA,iCAAA;AAnDJ;AAuDI;;EAEE,iCAAA;AArDN;AAyDM;EACE,yBC9UG;ADuRX;AAyDM;EACE,yBC3WO;ADoTf;AA2DI;EACE,cCjXU;EDkXV,4EAAA;EACA,yCAAA;EAAA,iCAAA;AAzDN;AA2DM;EACE,cCrXO;EDsXP,4EAAA;AAzDR;AA4DM;EACE,WCpXA;EDqXA,4EAAA;AA1DR","sourcesContent":["@import \"../../../Global/Colors.scss\";\n\ndiv.Button {\n  display: inline-block;\n  border: none;\n\n  background-color: $DeepSeaGreen;\n  color: $ElectricGreen;\n\n  font-size: 12px;\n  font-weight: 700;\n\n  padding: 16px 16px;\n  cursor: pointer;\n\n  user-select: none;\n  border-radius: 12px;\n\n  &.accept {\n    color: $ElectricGreen;\n    background-color: $DeepSeaGreen;\n    &:not(.button-menu-div) {\n      &:hover {\n        color: $White;\n        background-color: $Green140;\n      }\n    }\n  }\n\n  &.red {\n    color: $White;\n    background-color: $Red;\n    &:hover {\n      background-color: $Red120;\n    }\n  }\n\n  &.premium {\n    background: url(\"~images/highlight_star.svg\") no-repeat right 10px center;\n    background-size: 20px;\n  }\n\n  &.filter {\n    background-color: $White;\n    color: $DeepSeaGreen;\n    font-size: 17px;\n    text-decoration: underline;\n    &:hover {\n      color: $ElectricGreen;\n      text-decoration: none;\n    }\n    &.selected {\n      color: $Green;\n      text-decoration: none;\n    }\n    .button-menu {\n      text-decoration: none;\n      margin-top: 4px !important;\n      box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n      border: 1px solid $Gray30;\n      border-radius: 12px;\n      background-color: $White;\n      padding: 8px;\n      position: fixed;\n      &:before {\n        border-color: $Gray30 transparent;\n        margin-top: -3px;\n        right: 40px;\n      }\n      &:after {\n        border-color: white transparent;\n        margin-top: -1px;\n        right: 40px;\n      }\n    }\n  }\n\n  &.filterDropDown {\n    background-color: $White;\n    color: $DeepSeaGreen;\n    padding: 8px !important;\n    border-color: $White !important;\n    &:hover {\n      color: $ElectricGreen;\n      background-color: $DeepSeaGreen;\n    }\n    &.selected {\n      color: $DeepSeaGreen;\n    }\n  }\n\n  &.disabled {\n    background-color: $Gray20;\n    color: $Gray50;\n    cursor: not-allowed;\n    pointer-events: none;\n\n    .loadingEllipsis {\n      height: 14px;\n      margin-bottom: 2px;\n      margin-top: -3px;\n      .lds-ellipsis {\n        height: 14px;\n        div {\n          top: initial;\n          background: $DayGrey;\n          margin-top: 4px;\n        }\n      }\n    }\n  }\n\n  &.acceptDisabled {\n    color: $Gray50;\n    background-color: $Gray20;\n  }\n\n  &:active {\n    background-color: $DeepSeaGreen;\n\n    &.accept {\n      background-color: $Green140;\n    }\n    &.cancel {\n      background-color: $Gray90;\n    }\n    &.disabled {\n      background-color: $Gray50;\n    }\n    &.filter {\n      background-color: $Gray20;\n    }\n  }\n\n  &.link {\n    color: $DeepSeaGreen;\n    background-color: transparent;\n    white-space: nowrap;\n    border: none;\n    border-radius: 0;\n    padding: 0;\n    font-size: 14px;\n    text-decoration: underline;\n    width: fit-content;\n    background-image: linear-gradient(transparent 50%, $ElectricGreen 0%);\n    background-size: auto 200%;\n    transition: background 0.14s ease-in-out;\n\n    &:hover {\n      background-position-y: 100%;\n      text-decoration: none;\n    }\n  }\n\n  transition: background-color 0.3s;\n\n  &.normal {\n    color: $DeepSeaGreen;\n    background-color: $White;\n    border: 1px solid $Gray50;\n    box-shadow: 0 2px 4px 0 rgba($Gray60, 0.2);\n    &:hover {\n      background-color: $Gray30;\n    }\n  }\n\n  &.premium {\n    background: $DeepSeaGreen url(\"~images/highlight_star.svg\") no-repeat right 10px center;\n    background-size: 20px;\n    &:hover {\n      background-color: $Green140;\n    }\n  }\n\n  &.cancel {\n    color: $Gray90;\n    background-color: $White;\n    border: none;\n    &:hover {\n      background-color: rgba($Gray60, 0.12);\n    }\n  }\n\n  &.companyName {\n    width: 100% !important;\n    border-radius: 0px;\n    height: 20px;\n    line-height: 20px !important;\n  }\n\n  &.green-disabled {\n    background-color: $Green20;\n\n    &:hover {\n      background-color: $Green20 !important;\n    }\n  }\n\n  img.premium-star {\n    height: 10px !important;\n    width: 10px !important;\n    padding: 3px 7px 5px 5px;\n    float: right;\n\n  }\n\n  img.icon {\n    height: 15px;\n    width: 15px;\n    float: left;\n    margin-right: 18px;\n  }\n}\n\ndiv.button-menu-div {\n  display: inline-block;\n  padding: 0;\n\n  &:active {\n    background-color: $DeepSeaGreen;\n    &.accept {\n      background-color: $DeepSeaGreen;\n    }\n    &.cancel {\n      background-color: $Gray90;\n    }\n    &.filter {\n      background-color: $White;\n    }\n    &.link {\n      background-color: $White;\n    }\n  }\n\n  &.link {\n    > div.button-menu {\n      position: fixed;\n      background-color: $White;\n      box-shadow: 0 10px 15px 0 rgba($Gray200, 0.15);\n      margin-left: -35px;\n      margin-top: 15px;\n      padding: 10px !important;\n      border: 1px solid $Gray30;\n\n      > div.Button {\n        padding: 5px 8px !important;\n        border-top: none !important;\n        margin: 0 !important;\n      }\n      hr {\n        margin: 5px 8px 5px 8px;\n      }\n      &:after,\n      &:before {\n        right: 10px !important;\n      }\n      &:before {\n        border-color: $Gray30 transparent;\n        margin-top: -3px;\n      }\n      &:after {\n        border-color: white transparent;\n        margin-top: -1px;\n      }\n    }\n    > .menu-base {\n      padding: 0;\n    }\n  }\n\n  &.normal,\n  &.accept {\n    .button-menu {\n      &:after,\n      &:before {\n        left: calc(50% - 10px);\n        top: -5px;\n      }\n    }\n  }\n\n  > .menu-base {\n    border-right: 0;\n    display:inline-block;\n    padding: 16px;\n  }\n\n  .dropdown {\n    border-radius: 12px;\n    background: $DeepSeaGreen url(ButtonDropdown.svg) no-repeat center;\n    background-size: 12px;\n    padding: 16px 20px;\n    display:inline;\n    transition: background-color 0.3s;\n\n    &:active {\n      background-color: $DeepSeaGreen;\n    }\n    &:hover {\n      background-color: $Green140;\n    }\n    &.link {\n      padding-right: 10px !important;\n    }\n  }\n\n  > div.menu-hidden {\n    display:none !important;\n  }\n\n  > div.button-menu {\n    position: absolute;\n    z-index: 1000;\n    display: block;\n    margin-top: 10px;\n    padding: 2px 0 0 0;\n    border-radius: 12px;\n\n    > div.Button {\n      border-radius: 8px;\n      display: block;\n      padding: 14px 16px;\n    }\n\n    > div.Button:first-child {\n      border-radius: 8px;\n      border-top: none;\n    }\n\n    > div.Button:last-child {\n      border-radius: 8px;\n    }\n\n  }\n\n  > div.button-menu:before,\n  > div.button-menu:after  {\n    content:\"\";\n    position:absolute;\n    display:block;\n    width:0;\n    bottom:auto;\n    border-style:solid;\n    border-width:0 8px 8px;\n  }\n  > div.button-menu:after  {\n    top:-5px;\n    border-color:$Purple transparent;\n  }\n  > div.button-menu:before  {\n    top:-5px;\n    border-color:$Purple transparent;\n  }\n\n  &.accept {\n    >div.button-menu:after,\n    >div.button-menu:before {\n      border-color: $DeepSeaGreen transparent;\n    }\n\n    > .menu-base {\n      &:active {\n        background-color: $Green140;\n      }\n      &:hover {\n        background-color: $DeepSeaGreen;\n      }\n    }\n\n    .dropdown {\n      color: $ElectricGreen;\n      background: $DeepSeaGreen url(./dropdown-arrow-electricGreen.svg) no-repeat center;\n      transition: background-color 0.3s;\n\n      &:active {\n        color: $DeepSeaGreen;\n        background: $ElectricGreen url(./dropdown-arrow-electricGreen.svg) no-repeat center;\n\n      }\n      &:hover {\n        color: $White;\n        background: $Green140 url(./dropdown-arrow-electricGreen.svg) no-repeat center;\n\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
